export const academyNameTrademarkNotice = "Do not use registered trademarks in your academy name."

export const commonAcademyNameTrademarks = [
	"adidas",
	"amazon",
	"apple",
	"binance",
	"chatgpt",
	"coinbase",
	"disney",
	"facebook",
	"google",
	"instagram",
	"kraken",
	"lego",
	"meta",
	"metamask",
	"microsoft",
	"netflix",
	"nike",
	"openai",
	"paypal",
	"revolut",
	"spotify",
	"stripe",
	"tiktok",
	"wise",
	"youtube",
] as const

const commonTrademarkPattern = new RegExp(`\\b(${commonAcademyNameTrademarks.join("|")})\\b`, "i")
const commonTrademarkSlugs = commonAcademyNameTrademarks.map(toAcademySlugValidationToken)

export function getAcademyNameValidationError(name: string): string | null {
	if (name.trim().length === 0) return "Academy name is required."
	if (commonTrademarkPattern.test(name)) return academyNameTrademarkNotice
	return null
}

export function getAcademySlugValidationError(slug: string): string | null {
	const normalizedSlug = toAcademySlugValidationToken(slug)
	if (normalizedSlug.length === 0) return "Academy subdomain is required."

	const slugParts = normalizedSlug.split("-")
	if (commonTrademarkSlugs.some(trademark => slugParts.includes(trademark))) {
		return academyNameTrademarkNotice
	}

	return null
}

function toAcademySlugValidationToken(value: string): string {
	return value
		.trim()
		.toLowerCase()
		.normalize("NFKD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
}
